import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import ProductCountries from '../../Components/Header/ProductCountries';
import formatPrice from '../../Components/formatPrice';
import GradeIcon from '@mui/icons-material/Grade';
import Skeleton from '@material-ui/lab/Skeleton';
import FetchPriceLoader from '../../Components/FetchPriceLoader';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
var moment = require('moment');

/**
 * Renders the product cards. Must be placed inside <div className="sr-grid">.
 * Data logic (prices, stock, socket updates, links) is unchanged from the original.
 */
function ApisSearchResults({ getProducts, userData, isFetching, productUpdates }) {
  const { t } = useTranslation()
  const location = useLocation();
  const searchCountry = new URLSearchParams(location.search).get('country') || null

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      // return getTimeline()
      return `${t('delivery_by')} ${moment().add(14, 'days').format('Do MMM')}`
    } else {
      return `${t('delivery_by')} ${moment().add(14, 'days').format('Do MMM')}`
    }
  }

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }

  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.onerror = null; // avoid an infinite loop if the fallback is missing too
    e.target.src = '/Image-not-found.jpg';
  };

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12, 26]
  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }

  function checkIfAnyNumber(badge) {
    return /\d|×/.test(badge)
  }

  function removeDuplicates(inputString) {
    const lowerInput = inputString?.toLowerCase();
    if (lowerInput?.includes('prime') || lowerInput?.includes('amazon')) {
      return false;
    }
    const wordsArray = inputString?.split(/\s+/);
    const uniqueWords = [...new Set(wordsArray)];
    const result = uniqueWords?.join(' ');
    return result;
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false
    }
    if (fetch && country != itemCountry) {
      return true
    }
    return false
  }

  // Percentage off, worked out from the two prices the card already shows.
  // Returns 0 (badge hidden) unless both are plain numbers and the deal is real.
  function discountPercent(prices) {
    const was = Number(prices?.price)
    const now = Number(prices?.value)
    if (!prices?.deal_value || !Number.isFinite(was) || !Number.isFinite(now)) return 0
    if (was <= 0 || now >= was) return 0
    return Math.round(((was - now) / was) * 100)
  }

  return (
    <>
      {getProducts?.map((item, i) => {
        const selectedShipping = productUpdates?.find((s) => s.id === item.id)
        const prices = item?.prices ? item?.prices : selectedShipping?.prices
        const inStock = item?.in_stock ? item?.in_stock : selectedShipping?.in_stock
        const brand = item?.brand ? item?.brand : selectedShipping?.brand
        const dealbBadge = item?.deal_badge ? item?.deal_badge : selectedShipping?.deal_badge

        const priceLoading = !item?.prices && !selectedShipping?.prices
        const hasFlashDeal = Boolean(item?.prices?.deal_value)
        const dealText = checkIfAnyNumber(dealbBadge) ? false : removeDuplicates(dealbBadge)
        const badgeLabel = dealText || (hasFlashDeal ? t('deal', 'Deal') : null)
        const isCheckPrice = Number(prices?.bdp) === 0
        const unavailable = !priceLoading && !isCheckPrice && !inStock
        const off = discountPercent(prices)

        return (
          <Link
            key={i}
            className={`sr-card${unavailable ? ' is-unavailable' : ''}`}
            to={`/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}
          >
            <div className="sr-card__media">
              {badgeLabel && (
                <div className="sr-card__badges">
                  <span className={`sr-badge${hasFlashDeal ? ' sr-badge--deal' : ''}`}>
                    {hasFlashDeal && <FlashOnIcon style={{ fontSize: 14 }} />}
                    {badgeLabel}
                  </span>
                </div>
              )}
              <img
                className="sr-card__img"
                src={item?.image}
                alt={item?.title || ''}
                loading="lazy"
                decoding="async"
                onError={handleError}
              />
            </div>

            <div className="sr-card__body">
              <div className="sr-card__brand">{brand}</div>

              <h3 className="sr-card__title" title={item?.title}>
                {item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}
              </h3>

              <div className="sr-card__rating" aria-label={ratingFucn(item?.rating) ? `Rated ${item?.rating} out of 5` : undefined}>
                {ratingFucn(item?.rating) && (
                  <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                    <GradeIcon />
                    {item?.rating}
                  </div>
                )}
                   {loadCountrySkeleton(isFetching, searchCountry, item?.country) ? (
                  <Skeleton style={{ height: '16px', width: '50%' }} />
                ) : (
                  <span className="sr-card__meta">
                    <span>{t('From')}</span>
                    <span className="sr-card__unit">
                      <img
                        className="sr-card__flag"
                        loading="lazy"
                        src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      {ProductCountries(item?.country)}
                    </span>
                  </span>
                )}
              </div>

              <div className="sr-card__price">
                {priceLoading ? (
                  <FetchPriceLoader />
                ) : isCheckPrice ? (
                  <span className="sr-pill">Check price</span>
                ) : inStock ? (
                  <>
                    <span className={`sr-card__now${prices?.deal_value ? ' is-deal' : ''}`}>
                      {formatPrice(prices?.value, prices?.currency, 0)}
                    </span>
                    {prices?.deal_value && (
                      <s className="sr-card__was">{formatPrice(prices?.price, prices?.currency, 0)}</s>
                    )}
                    {off > 0 && <span className="sr-card__off">{`-${off}%`}</span>}
                  </>
                ) : (
                  <span className="sr-card__unavailable">Currently unavailable</span>
                )}
              </div>
              {priceLoading && <span className="sr-card__fetching">Fetching best offer</span>}

              <div className="sr-card__foot">
                <span className="sr-card__meta sr-card__meta--delivery">
                  <LocalShippingOutlinedIcon style={{ fontSize: 15 }} />
                  <span>{getDeliverydays(item.estimated_delivery)}</span>
                </span>

             
              </div>
            </div>
          </Link>
        )
      })}
    </>
  )
};

export default ApisSearchResults;